export default (api) => ({
  register: (data) => api.post('register/', data),
  login: (data) => api.post('login/', data),
})
